export const LOGIN_ACTIONS_TYPES={
    LOGIN:"LOGIN",
    LOGOUT:"LOGOUT",
    LOGIN_LOADING: "LOGIN_LOADING",
    SCROLL: "SCROLL",
}